module.exports = __webpack_public_path__ + "static/media/pgp.019fcc1c.svg";